import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'types';
import { initialPaginationState, initialState } from '.';
import { PaginationType } from './types';

const selectSlice = (state: RootState) => state.pagination || initialState;

export const selectPagination = createSelector([selectSlice], state => state);

export const selectPaginationByType = (pagiType: PaginationType) =>
  createSelector(
    [selectSlice],
    state => state[pagiType] ?? initialPaginationState,
  );

export const selectPagination_NoContentByType = (pagiType: PaginationType) =>
  createSelector([selectSlice], state => ({
    ...(state[pagiType] ?? initialPaginationState),
    content: undefined,
  }));

export const selectPaginationContentOnlyByType = (pagiType: PaginationType) =>
  createSelector(
    [selectSlice],
    state => state[pagiType]?.content ?? initialPaginationState.content,
  );

export const selectPaginationContentAsPreSearchable = (
  pagiType: PaginationType,
) =>
  createSelector([selectPaginationContentOnlyByType(pagiType)], content => {
    if (content?.['0']) {
      return content['0'];
    } else {
      return {
        data: [],
        loading: false,
        error: true,
      };
    }
  });
